module.exports = __webpack_public_path__ + "img/type_reefer_link.7b42641b.jpg";